// This is a rare instance where is okay to use process.env in the frontend,
// because the value that hardcoded during the build is also valid at runtime.
const isNewConsumerApp = !!process.env.NEXT_PUBLIC_IS_NEXT_APP;

export default isNewConsumerApp;
